import * as React from 'react';

import { Card, CardText } from 'material-ui/Card';
import { GlancePair, Partner, Region, StudioAppConfig } from 'glance-datatypes';

import GlanceDetailsCard from './GlanceDetailsCard';
import GlanceWallpaperCard from './GlanceWallpaperCard';
import { GridList } from 'material-ui';
import Utils from '../Utils';

const styles = {
    cardTextDiv : {
        padding:'5px',
        display: 'flex',
        margin:'0px auto',
        maxHeight: '70vh',
        overflow: 'auto',
    },
    glanceCard: {
        height: '100%',
        flexFlow:'column',
        display: 'flex',
    },
    wallpaperDiv : {
        padding:'5px',
    },
    wallpaper: {
        maxWidth:'60%',
        display: 'block',
        margin:'0px auto',
    },
};

interface Props {
    data: GlancePair;
    partner: Partner;
    customStyle?: React.CSSProperties;
    actions?: any;
    detailedView?: boolean;
    region: Region;
    studioAppConfig?: StudioAppConfig;
}

class GlanceCard extends React.Component<Props, {}> {
    constructor(props: Props) {
        super(props);
    }

    render() {
        const renderSession = Utils.getRenderSessionData(this.props.data.data);
        const wallpaperWidth: string = this.props.detailedView ? '50%' : '100%';
        const detailsWidth: string = this.props.detailedView ? '50%' : '100%';
        const flexFlow = this.props.detailedView ? 'row': 'column';
        const userActions = this.props.actions ? this.props.actions.filter(action => action.key !== 'state_button' && action.key !== 'select_button') : [];

        const selectButton = this.props.actions ? this.props.actions.find(action => action.key === 'select_button'): null;
        const stateLabel = this.props.actions ? this.props.actions.find(action => action.key === 'state_button'): null;

        return (
            <Card style={{...this.props.customStyle, height: '100%'}} containerStyle={styles.glanceCard}>
                <CardText style={{padding: '2px'}}>
                    <div className='display-flex' style={{margin:'0px auto', display:'flex', flexFlow: flexFlow, position:'relative'}}>
                     {selectButton}
                        <div className='' style={{width: wallpaperWidth,minHeight:'330px', ...styles.wallpaperDiv}}>
                            <GlanceWallpaperCard
                                customStyle={styles.wallpaper}
                                renderSessionProperties={renderSession}
                                image={this.props.data.data.image}
                                overlayImage={this.props.data.data.overlayImage}
                                type={this.props.data.data.type}
                                partner={this.props.partner}
                                studioAppConfig={this.props.studioAppConfig}
                                spaceData={this.props.data.data.spaceData}
                                destinationIdentifier={this.props.data.data.destinationIdentifier}/>
                        </div>
                        {stateLabel}
                        <div className='display-flex' style={{width: detailsWidth, ...styles.cardTextDiv}}>
                            <GlanceDetailsCard
                                glance={this.props.data}
                                detailedView={this.props.detailedView}
                                region={this.props.region}
                                partner={this.props.partner}
                                studioAppConfig={this.props.studioAppConfig}
                            />
                        </div>
                    </div>
                </CardText>
                {
                    userActions.length > 0 ?
                    <GridList cols={userActions.length} padding={5} cellHeight='auto' style={
                       {flex: 1,alignItems:'flex-end'}
                    }>
                    {
                           userActions
                        }
                    </GridList>

                    : ''
                }
            </Card>
        );
    }
}

export default GlanceCard;



// WEBPACK FOOTER //
// ./src/components/GlanceCard.tsx